/**
 * Relevant für die Playerleiste und den Radioteaser.
 *
 * @namespace RadioData
 * @aka SWRNEU.RadioData
 */
(function ($) {
  const TEMPLATES = {
    SHOW_INFO_WITH_LINK: '<a href="{url}">{text}</a>',
    ACTION_BUTTON: '' +
      '<li>' +
      '  <a class="btn btn-secondary btn-secondary-neutral btn-small" href="{url}" {target}>{icon}{label}</a>' +
      '</li>',
    SHOW_INFO_ITEM: '' +
      '<dt class="sr-only">{description}</dt>' +
      '<dd class="onair-episode-info-{class}">{text}</dd>',
    SHOW_INFO: '' +
      '<div class="show-info">' +
      '  <time class="onair-episode-time" datetime="{timestamp}" aria-label="Von {starttime} bis {endtime} Uhr">' +
      '    <span>{starttime}<span class="sr-only">Uhr</span></span><span aria-hidden="true">&nbsp;–&nbsp;</span><span class="sr-only">bis</span><span>{endtime}<span class="sr-only">Uhr</span></span>' +
      '  </time>' +
      '  <dl class="onair-episode-info">' +
      '    {title}' +
      '    {subTitle}' +
      '    {presenters}' +
      '  </dl>' +
      '</div>',
    SHOW_COVER: '' +
      '<figure class="onair-episode-cover" aria-hidden="true">' +
      '  <div class="image">' +
      '    <img src="{image}" alt="{alt}" data-copyright="Foto: SWR" width="{width}" height="{height}">' +
      '  </div>' +
      '</figure>',
    SHOW_COVER_SVG: '' +
      '<div class="fallback-episode-cover" aria-hidden="true">' +
      '  <div class="image">{svg}</div>' +
      '</div>',
    WELLENSWITCHER: '' +
      '<ul class="station-list collapse" id="{id}">' +
      '  {stationItems}' +
      '</ul>',
    WELLENSWITCHER_ITEM: '' +
      '<li class="station-item {activeClass}">' +
      '  <button class="btn btn-station btn-tertiary-neutral {activeClass}" type="button" data-spy="audioplayer" data-stationid="{stationId}" data-config-uri="{configUri}">{stationName}</button>' +
      '</li>'
  };

  const _requestsInProgress = new Map(); // stationId -> Promise
  let _subscriptions = [];
  let _jsonUrls = {};

  /**
   * Ermittelt die Konfigurations-URLs für die verschiedenen Radiostationen.
   * Versucht zunächst, diese aus dem DOM (Wellenswitcher-Elemente) zu lesen.
   * Falls diese nicht vorhanden sind, wird auf eine interne Liste von Standard-URLs zurückgegriffen.
   *
   * @private
   */
  function _getJsonUrls () {
    const $stationsIds = $('#playerbar #stations').find('[data-stationid]');

    if ($stationsIds.length === 0) {
      //Wenn kein Wellenswitcher in der Playerleiste vorhanden ist,
      //werden die Standard-URLs verwendet:
      _jsonUrls = {
        dasding: {
          configUri: 'https://www.swr.de/~webradio/administration/playerbar-swr3/dasding-playerbar-swr-100~playerbarContainer.json',
          displayName: 'DASDING',
          showFeedUrl: null,
          playlistFeedUrl: null
        },
        swraktuell: {
          configUri: 'https://www.swr.de/~webradio/swraktuell/playerbar/swraktuell-playerbar-100~playerbarContainer.json',
          displayName: 'SWR Aktuell',
          showFeedUrl: null,
          playlistFeedUrl: null
        },
        swr1bw: {
          configUri: 'https://www.swr.de/~webradio/swr1/bw/swr1bw-playerbar-100~playerbarContainer.json',
          displayName: 'SWR1 Baden-Württemberg',
          showFeedUrl: null,
          playlistFeedUrl: null
        },
        swr1rp: {
          configUri: 'https://www.swr.de/~webradio/swr1/rp/swr1rp-playerbar-100~playerbarContainer.json',
          displayName: 'SWR1 Rheinland-Pfalz',
          showFeedUrl: null,
          playlistFeedUrl: null
        },
        swr2: {
          configUri: 'https://www.swr.de/~webradio/swr2/swr2-playerbar-102~playerbarContainer.json',
          displayName: 'SWR Kultur Radio',
          showFeedUrl: null,
          playlistFeedUrl: null
        },
        swr3: {
          configUri: 'https://www.swr.de/~webradio/administration/playerbar-swr3/swr3-playerbar-100~playerbarContainer.json',
          displayName: 'SWR3',
          showFeedUrl: null,
          playlistFeedUrl: null
        },
        swr4st: {
          configUri: 'https://www.swr.de/~webradio/swr4/nachrichten/stuttgart/stuttgart-playerbar-100~playerbarContainer.json',
          displayName: 'SWR4 Stuttgart',
          showFeedUrl: null,
          playlistFeedUrl: null
        },
        swr4fr: {
          configUri: 'https://www.swr.de/~webradio/swr4/nachrichten/suedbaden/suedbaden-playerbar-100~playerbarContainer.json',
          displayName: 'SWR4 Freiburg',
          showFeedUrl: null,
          playlistFeedUrl: null
        },
        swr4fn: {
          configUri: 'https://www.swr.de/~webradio/swr4/nachrichten/friedrichshafen/swr4fn-playerbar-100~playerbarContainer.json',
          displayName: 'SWR4 Friedrichshafen',
          showFeedUrl: null,
          playlistFeedUrl: null
        },
        swr4hn: {
          configUri: 'https://www.swr.de/~webradio/swr4/nachrichten/heilbronn/swr4hn-playerbar-100~playerbarContainer.json',
          displayName: 'SWR4 Heilbronn',
          showFeedUrl: null,
          playlistFeedUrl: null
        },
        swr4kl: {
          configUri: 'https://www.swr.de/~webradio/swr4/nachrichten/kaiserslautern/swr4kl-playerbar-100~playerbarContainer.json',
          displayName: 'SWR4 Kaiserslautern',
          showFeedUrl: null,
          playlistFeedUrl: null
        },
        swr4ka: {
          configUri: 'https://www.swr.de/~webradio/swr4/nachrichten/karlsruhe/karlsruhe-playerbar-100~playerbarContainer.json',
          displayName: 'SWR4 Karlsruhe',
          showFeedUrl: null,
          playlistFeedUrl: null
        },
        swr4ko: {
          configUri: 'https://www.swr.de/~webradio/swr4/nachrichten/koblenz/koblenz-playerbar-100~playerbarContainer.json',
          displayName: 'SWR4 Koblenz',
          showFeedUrl: null,
          playlistFeedUrl: null
        },
        swr4lu: {
          configUri: 'https://www.swr.de/~webradio/swr4/nachrichten/ludwigshafen/ludwigshafen-playerbar-100~playerbarContainer.json',
          displayName: 'SWR4 Ludwigshafen',
          showFeedUrl: null,
          playlistFeedUrl: null
        },
        swr4mz: {
          configUri: 'https://www.swr.de/~webradio/swr4/nachrichten/mainz/swr4mz-playerbar-100~playerbarContainer.json',
          displayName: 'SWR4 Mainz',
          showFeedUrl: null,
          playlistFeedUrl: null
        },
        swr4ma: {
          configUri: 'https://www.swr.de/~webradio/swr4/nachrichten/mannheim/mannheim-playerbar-100~playerbarContainer.json',
          displayName: 'SWR4 Mannheim',
          showFeedUrl: null,
          playlistFeedUrl: null
        },
        swr4tr: {
          configUri: 'https://www.swr.de/~webradio/swr4/nachrichten/trier/trier-playerbar-100~playerbarContainer.json',
          displayName: 'SWR4 Trier',
          showFeedUrl: null,
          playlistFeedUrl: null
        },
        swr4tu: {
          configUri: 'https://www.swr.de/~webradio/swr4/nachrichten/tuebingen/tuebingen-playerbar-100~playerbarContainer.json',
          displayName: 'SWR4 Tübingen',
          showFeedUrl: null,
          playlistFeedUrl: null
        },
        swr4ul: {
          configUri: 'https://www.swr.de/~webradio/swr4/nachrichten/ulm/ulm-playerbar-100~playerbarContainer.json',
          displayName: 'SWR4 Ulm',
          showFeedUrl: null,
          playlistFeedUrl: null
        }
      };
    } else {
      //Ansonsten werden die URLs aus dem Wellenswitcher in der Playerleiste verwendet:
      $stationsIds.each(function () {
        let configUri = $(this).attr('data-config-uri') || null;

        //Um Problemen vorzubeugen, wird immer die Basis-URL von SWR.de
        //vorangestellt, damit die Config-URL auch in lokalen Entwicklungsumgebungen
        //oder auf Testservern funktioniert und richtige Inhalte liefert.
        //Beispielsweise auf demo.swr.de und im Localhost liegen keine Live-Daten vor.
        const splitIndex = configUri.indexOf('~webradio');

        if (splitIndex !== -1) {
          configUri = configUri.substring(splitIndex, configUri.length);

          configUri = 'https://www.swr.de/' + configUri;
        }

        /*
        Dynamische Anpassung der Config-URL, damit sie auch in lokalen Entwicklungsumgebungen oder auf Testservern funktioniert.
        Wird aktuell nicht benötigt, da wir auf den Testsystemen nicht ausreichend Sendungsdaten haben.
        if (configUri) {
          let configUrl = new URL(configUri, window.location.origin);
          let parts = configUrl.hostname.split('.');
          let site = parts[Math.max(0, parts.length - 2)].toLowerCase();

          if (window.location.host === 'localhost:8080') {
            configUrl.pathname = configUrl.pathname.replace('/~webradio/', '/cms/' + site + '~webradio/');
          } else if (!/(www|standby|live-origin|beta[1-3]|demo)\.[^.]+\.de/i.test(window.location.hostname)) {
            configUrl.pathname = configUrl.pathname.replace('/~webradio/', '/' + site + '~webradio/');
          }
          configUrl.protocol = window.location.protocol;
          configUrl.host = window.location.host;

          configUri = configUrl.href;
        }*/

        _jsonUrls[$(this).attr('data-stationid')] = {
          configUri: configUri,
          displayName: $(this).text().trim(),
          showFeedUrl: null,
          playlistFeedUrl: null
        };
      });
    }
  }

  _getJsonUrls();

  /**
   * Registriert Event-Listener für das globale `common:data` Event.
   * Verarbeitet eingehende Daten-Updates und leitet sie als spezifische Events
   * (`swr:radiodata:playlist` oder `swr:radiodata:show`) weiter.
   *
   * @private
   */
  function _handleSubscriptionEvents () {
    $(document).on('common:data', function (event, options) {
      const key = options.id + '.' + options.key;

      switch (options.key) {
        case 'playlist':
          $(document).trigger('swr:radiodata:playlist', {
            stationId: options.id,
            playlist: getDataFromStorage(key)
          });
          break;
        case 'show':
          $(document).trigger('swr:radiodata:show', {
            stationId: options.id,
            show: getDataFromStorage(key)
          });
          break;
      }
    });
  }

  _handleSubscriptionEvents();

  /**
   * Hilfsfunktion zum Abonnieren eines JSON-Feeds über das globale Event-System.
   * Fügt das Abonnement der internen Liste hinzu und triggert `common:data:subscribe`.
   *
   * @param {string} feedUrl - Die URL des Feeds.
   * @param {number} interval - Das Abrufintervall in Millisekunden.
   * @param {string} stationId - Die ID der Station.
   * @param {string} alias - Der Alias für den Feed (z.B. 'show', 'playlist').
   * @private
   */
  function _subscribeJSON (feedUrl, interval, stationId, alias) {
    console.log('subscribeJSON', feedUrl, interval, stationId, alias);
    $(document).trigger('common:data:subscribe', [stationId + ':' + alias, {
      url: feedUrl,
      interval: interval,
      alias: alias
    }]);

    _subscriptions.push({
      stationId: stationId,
      alias: alias
    });

    console.log(_subscriptions);
  }

  /**
   * Abonniert einen spezifischen Feed-Typ (Show oder Playlist) für eine Station.
   * Wählt das passende Intervall basierend auf dem Typ.
   *
   * @param {string} feedUrl - Die URL des Feeds.
   * @param {string} type - Der Typ des Feeds ('show' oder 'playlist').
   * @param {string} stationId - Die ID der Station.
   */
  function subscribeFeed (feedUrl, type, stationId) {
    switch (type) {
      case 'show':
        _subscribeJSON(feedUrl, 30e3, stationId, 'show');
        break;
      case 'playlist':
        _subscribeJSON(feedUrl, 10e3, stationId, 'playlist');
        break;
    }
  }

  /**
   * Unsubscribed Feeds für eine Station ab.
   * Kann entweder alle Feeds einer Station oder nur einen spezifischen Typ abbestellen.
   *
   * @param {string} stationId - Die ID der Station.
   * @param {string} [type='all'] - Der Typ des Feeds ('all', 'show', 'playlist').
   */
  function unsubscribeFeed (stationId, type = 'all') {
    var keep = [];

    console.log('unsubscribeJSON', stationId, type);

    //Alle Subscriptions werden durchgegangen:
    _subscriptions.forEach(function (item) {
      if (item.stationId !== stationId) {
        //Behalten
        keep.push(item);
      } else {
        if (type === 'all') {
          //Alle Subscriptions der Station sollen unscribed werden:
          $(document).trigger('common:data:unsubscribe', [item.stationId + ':' + item.alias]);
        } else {
          if (item.alias !== type) {
            //Behalten
            keep.push(item);
          } else {
            //Wenn der Alias der Subscription dem Type entspricht, werden sie unsubscribed:
            $(document).trigger('common:data:unsubscribe', [item.stationId + ':' + item.alias]);
          }
        }
      }
    });

    _subscriptions = keep;
  }

  /**
   * Holt die Basis-JSON-Daten, die Audioplayer, Show, ShowFeedUrl, Playlist, PlaylistFeedUrl und Action-Links enthalten.
   * Verwaltet parallele Anfragen für dieselbe Station und nutzt Promises zur Synchronisation.
   * Speichert die empfangenen Daten im SessionStorage und startet ggf. Abonnements.
   *
   * @param {string} stationId - Die ID der Station.
   * @param {boolean} [links=true] - Ob Link-Daten verarbeitet werden sollen.
   * @param {boolean} [playlist=true] - Ob Playlist-Daten verarbeitet und abonniert werden sollen.
   * @param {boolean} [show=true] - Ob Sendungsdaten verarbeitet und abonniert werden sollen.
   * @returns {Promise<number>} Promise, das 1 bei Erfolg und -1 bei Fehler zurückgibt.
   */
  async function getData (stationId, links = true, playlist = true, show = true) {
    console.log('getData', stationId, links, playlist, show);
    const subscriptionsForStationId = _subscriptions.filter(subscription => subscription.stationId === stationId);

    if (subscriptionsForStationId.length !== 0) {
      //Es gibt bereits eine Subscription für die Station-ID,
      //daher können die Daten von dort verwendet werden
      console.log('Bereits in den Subscriptions vorhanden:', subscriptionsForStationId);
      return 1;
    }

    if (_requestsInProgress.has(stationId)) {
      //Wenn bereits ein Request für diese Station-ID läuft,
      //soll darauf gewartet werden. Es wird die gespeicherte
      //Promise zurückgeliefert
      console.log('Bereits in den Requests:', stationId);
      return _requestsInProgress.get(stationId);
    }

    const requestPromise = (async () => {
      let result = 0;
      try {
        const response = await fetch(_jsonUrls[stationId].configUri, {
          cache: 'no-cache',
          headers: {
            'Accept': 'application/json, */*; q=0.01',
            'X-Requested-With': 'XMLHttpRequest'
          },
          method: 'GET',
          credentials: 'same-origin'
        });

        if (!response.ok) {
           throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        console.log('success', data, stationId, links, playlist, show);
        result = 1;

        //Wenn der Request geklappt hat, werden die Daten gespeichert:
        COMMON.Storage.session.setItem(stationId + '.audioplayer', data.audioplayer ?? null);

        // SHOW
        if (data.show) {
          _jsonUrls[stationId].showFeedUrl = data.show.feedUrl || null;

          if (show) {
            //Wenn die Show-Daten gebraucht werden,
            //werden diese gespeichert und der Feed abonniert:
            COMMON.Storage.session.setItem(stationId + '.show', data.show.data);
            COMMON.Storage.session.setItem(stationId + '.show.detailHeadline', data.show.detailHeadline);
            _subscribeJSON(data.show.feedUrl, 30e3, stationId, 'show');
          }
        }

        // PLAYLIST
        if (data.playlist) {
          _jsonUrls[stationId].playlistFeedUrl = data.playlist.feedUrl || null;

          if (playlist) {
            //Wenn die Playlist-Daten gebraucht werden,
            //werden diese gespeichert und der Feed abonniert:
            COMMON.Storage.session.setItem(stationId + '.playlist', data.playlist.data);
            COMMON.Storage.session.setItem(stationId + '.playlist.headline', data.playlist.headline);
            _subscribeJSON(data.playlist.feedUrl, 10e3, stationId, 'playlist');
          }
        }

        // LINKS
        if (links) {
          COMMON.Storage.session.setItem(stationId + '.links', data.links ?? null);
        }

      } catch (error) {
        console.error('Request-Error', stationId, error);
        result = -1;
      } finally {
        // Request entfernen, egal ob erfolgreich oder fehlerhaft
        _requestsInProgress.delete(stationId);
      }

      return result;
    })();

    _requestsInProgress.set(stationId, requestPromise);
    console.log(_requestsInProgress);

    return requestPromise;
  }

  /**
   * Generiert das HTML für die Anzeige von Sendungsinformationen.
   * Beinhaltet Zeit, Titel, Untertitel und Moderatoren.
   *
   * @param {string} stationId - Die ID der Station (Standard: aktuelle Station).
   * @param {object} showInfos - Das Objekt mit den Sendungsinformationen.
   * @returns {string} Das generierte HTML.
   */
  function renderShowInfo (stationId = getCurrentStationId(), showInfos = getDataFromStorage(stationId + '.show')) {
    if (!showInfos) {
      return '';
    }

    const startTime = dayjs.unix(showInfos.starttime).utc();
    const endTime = dayjs.unix(showInfos.endtime).utc();
    let presenters = _getPresenters(stationId, showInfos);
    let title = showInfos.title;

    if (showInfos.url.hasOwnProperty('href')) {
      //Sendung hat einen Link:
      title = COMMON.Utils.template(TEMPLATES.SHOW_INFO_WITH_LINK, {
        url: showInfos.url.href,
        text: showInfos.title
      });
    }

    return COMMON.Utils.template(TEMPLATES.SHOW_INFO, {
      timestamp: startTime.local().format(),
      starttime: startTime.local().format('H:mm'),
      endtime: endTime.local().format('H:mm'),
      title: COMMON.Utils.template(TEMPLATES.SHOW_INFO_ITEM, {
        class: 'title',
        description: 'Titel der Sendung:',
        text: title
      }),
      subTitle: showInfos.subTitle.length !== 0 ? COMMON.Utils.template(TEMPLATES.SHOW_INFO_ITEM, {
        class: 'subtitle',
        description: 'Untertitel der Sendung:',
        text: showInfos.subTitle
      }) : '',
      presenters: presenters.length !== 0 ? COMMON.Utils.template(TEMPLATES.SHOW_INFO_ITEM, {
        class: 'presenter',
        description: 'Moderator/en:',
        text: function () {
          let result = '<span class="presenter-prefix" aria-hidden="true">Mit:&nbsp;</span>';

          for (const presenter of presenters) {
            result += presenter.presenter + '<span class="presenter-delimiter">,&nbsp</span>';
          }

          //Testweise können auch noch mehr Moderatoren hinzugefügt werden:
          //result += "THORSTEN" + '<span class="presenter-delimiter">,&nbsp</span>';
          //result += "RALF" + '<span class="presenter-delimiter">,&nbsp</span>';

          return result.substring(0, result.length - 47);
        }
      }) : ''
    });
  }

  /**
   * Generiert das HTML für das Sendungsbild.
   * Falls mehr als ein Moderator vorliegt, wird das Cover der Sendung verwendet, sonst das Bild des Moderators.
   *
   * @param {string} stationId - Die ID der Station (Standard: aktuelle Station).
   * @param {object} showInfos - Das Objekt mit den Sendungsinformationen.
   * @param {number} [width] - Optionale Breite für die Bildanforderung.
   * @returns {string} Das generierte HTML (figure/img Tag).
   */
  function renderShowImage (stationId = getCurrentStationId(), showInfos = getDataFromStorage(stationId + '.show'), width) {
    let presenters = _getPresenters(stationId, showInfos);
    let paramWidth = '';

    //Mit dem Parameter width kann eine verkleinerte
    //Version des Bildes bei Akamai angefordert werden.
    if ('undefined' !== typeof width) {
      paramWidth = '?width=' + width;
    } else {
      width = 380;
    }

    return COMMON.Utils.template(TEMPLATES.SHOW_COVER, {
      alt: function () {
        let result = 'Cover der Sendung: ' + showInfos.title;

        if (presenters.length === 1) {
          for (const presenter of presenters) {
            if (presenter.avatar !== '') {
              result = 'Bild des Moderators: ' + presenter.name;
              break;
            }
          }
        }

        return result;
      },
      image: function () {
        let result = showInfos.cover['1x1'];

        if (presenters.length === 1) {
          for (const presenter of presenters) {
            if (presenter.avatar !== '') {
              result = presenter.avatar;
              break;
            }
          }
        }

        return result + paramWidth;
      },
      width: width,
      height: width
    });
  }

  /**
   * Generiert das HTML für das Senderlogo (SVG) als Fallback-Bild.
   * Wird verwendet, wenn keine spezifischen Sendungsbilder verfügbar sind.
   *
   * @param {string} stationId - Die ID der Station.
   * @returns {string} Das generierte HTML.
   */
  function renderStationImage (stationId) {
    if (stationId !== 'swraktuell') {
      stationId = stationId.replace(/(bw|rp|fn|hn|ka|ma|st|fr|tu|ul|kl|ko|lu|mz|tr)/g, '');
    }

    const stationName = getStationDisplayName(stationId);

    if (stationId === 'swr2') {
      stationId = 'swrkultur';
    }

    return COMMON.Utils.template(TEMPLATES.SHOW_COVER_SVG, {
      alt: 'Logo des Senders: ' + stationName,
      svg: SWRNEU.Util.svgIcon(stationId, '', '', 'brands.svg')
    });
  }

  /**
   * Generiert das HTML der Action-Buttons (externe Links) für eine Station.
   * Begrenzt die Anzeige auf maximal 3 Links (wenn mehr als 3 vorhanden sind).
   *
   * @param {string} stationId - Die ID der Station.
   * @returns {string} Das generierte HTML.
   */
  function renderStationLinks (stationId) {
    let links = SWRNEU.RadioData.getDataFromStorage(stationId + '.links');
    let result = '';

    if (links && 0 !== links.length) {
      console.log('LINKS', links);

      if (links.length > 3) {
        //Falls mehr als 3 Links enthalten sind, werden alle, außer
        //die ersten 3 Links rausgeworfen.
        links = links.slice(0, 2);
      }

      for (const link of links) {
        const icon = link.classes.split(' ').pop();
        result += COMMON.Utils.template(TEMPLATES.ACTION_BUTTON, {
          url: link.url.href,
          target: stationId === 'dasding' || stationId === 'swr3' ? 'target="_blank"' : '',
          icon: SWRNEU.Util.svgIcon(icon.replace('icon-', '')),
          label: link.label
        });
      }
    }

    return result;
  }

  /**
   * Erstellt das HTML für das Dropdown-Menü zur Senderauswahl (Wellenswitcher).
   *
   * @param {string[]} stationIds - Array mit IDs der anzuzeigenden Stationen.
   * @param {string} defaultStation - Standard-Station des Wellenswitchers.
   * @param {string} replace - String, der aus dem Sendernamen entfernt werden soll (z.B. "SWR4") (Standard: '').
   * @param {string} id - Suffix für die HTML-ID des Dropdowns (Standard: generierte UUID).
   * @returns {string} Das generierte HTML für die Liste.
   */
  function renderWellenswitcher (stationIds, defaultStation = '', replace = '', id = COMMON.Utils.uuid()) {
    let wellenswitcherItems = [];

    if (stationIds.length === 0 || !Array.isArray(stationIds)) {
      return '';
    }

    for (const [key, value] of Object.entries(_jsonUrls)) {
      if (stationIds.includes(key)) {
        wellenswitcherItems.push(COMMON.Utils.template(TEMPLATES.WELLENSWITCHER_ITEM, {
          stationId: key,
          configUri: value.configUri,
          stationName: value.displayName.replace(replace, '').trim(),
          activeClass: key === defaultStation ? 'active' : ''
        }));
      }
    }

    return COMMON.Utils.template(TEMPLATES.WELLENSWITCHER, {
      id: 'radio-teaser-stations-' + id,
      stationItems: wellenswitcherItems.join('')
    });
  }

  /**
   * Liest Daten sicher aus dem SessionStorage.
   * Fängt Fehler ab, falls der Zugriff nicht möglich ist.
   *
   * @param {string} key - Der Schlüssel für den Storage.
   * @returns {any|null} Die gespeicherten Daten oder null.
   */
  function getDataFromStorage (key) {
    try {
      const data = COMMON.Storage.session.getItem(key);

      if ('undefined' === typeof data) {
        return null;
      } else {
        return COMMON.Storage.session.getItem(key);
      }
    } catch (e) {
      console.error('Es konnten keine Daten aus dem Storage abgefragt werden.');
      return null;
    }
  }

  /**
   * Löscht Daten (Playlist, Show, Audioplayer) einer Station aus dem SessionStorage.
   *
   * @param {string} stationId - Die ID der Station.
   * @param {string} [key='all'] - Der spezifische Schlüssel ('playlist', 'show', 'audioplayer', 'links). Wenn leer, wird alles gelöscht.
   */
  function removeDataFromStorage (stationId, key = 'all') {
    switch (key) {
      case 'playlist': {
        try {
          COMMON.Storage.session.removeItem(stationId + '.playlist');
          COMMON.Storage.session.removeItem(stationId + '.playlist.headline');
        } catch (e) {
          console.error('Es konnten keine Daten aus dem Storage entfernt werden.');
        }
        break;
      }
      case 'show': {
        try {
          COMMON.Storage.session.removeItem(stationId + '.show');
          COMMON.Storage.session.removeItem(stationId + '.show.detailHeadline');
        } catch (e) {
          console.error('Es konnten keine Daten aus dem Storage entfernt werden.');
        }
        break;
      }
      case 'audioplayer': {
        try {
          COMMON.Storage.session.removeItem(stationId + '.audioplayer');
        } catch (e) {
          console.error('Es konnten keine Daten aus dem Storage entfernt werden.');
        }
        break;
      }
      case 'links': {
        try {
          COMMON.Storage.session.removeItem(stationId + '.links');
        } catch (e) {
          console.error('Es konnten keine Daten aus dem Storage entfernt werden.');
        }
        break;
      }
      default: {
        try {
          COMMON.Storage.session.removeItem(stationId + '.audioplayer');
          COMMON.Storage.session.removeItem(stationId + '.show');
          COMMON.Storage.session.removeItem(stationId + '.show.detailHeadline');
          COMMON.Storage.session.removeItem(stationId + '.playlist');
          COMMON.Storage.session.removeItem(stationId + '.playlist.headline');
          COMMON.Storage.session.removeItem(stationId + '.links');
        } catch (e) {
          console.error('Es konnten keine Daten aus dem Storage entfernt werden.');
        }
      }
    }
  }

  /**
   * Speichert die ID der aktuell ausgewählten Station der Playerleiste im SessionStorage.
   *
   * @param {string} stationId - Die ID der Station.
   */
  function setCurrentStationId (stationId) {
    COMMON.Storage.session.setItem('currentStationId', stationId);
  }

  /**
   * Liest die ID der aktuellen Station aus dem SessionStorage.
   *
   * @returns {string|null} Die ID der Station oder null.
   */
  function getCurrentStationId () {
    return getDataFromStorage('currentStationId');
  }

  /**
   * Gibt den Anzeigenamen einer Station basierend auf ihrer ID zurück.
   *
   * @param {string} [stationId] - Die ID der Station (Standard: aktuelle Station).
   * @returns {string|null} Der Anzeigename oder null.
   */
  function getStationDisplayName (stationId = getCurrentStationId()) {
    console.log(_jsonUrls);
    return _jsonUrls[stationId] ? _jsonUrls[stationId].displayName : null;
  }

  /**
   * Ermittelt die URL für einen bestimmten Feed-Typ (Show/Playlist) einer Station.
   *
   * @param {string} stationId - Die ID der Station.
   * @param {string} type - Der Typ des Feeds ('show' oder 'playlist').
   * @returns {string|null} Die URL oder null.
   */
  function getFeedUrl (stationId, type) {
    if (_jsonUrls[stationId]) {
      if (type === 'show') {
        return _jsonUrls[stationId].showFeedUrl;
      } else if (type === 'playlist') {
        return _jsonUrls[stationId].playlistFeedUrl;
      }
    }

    return null;
  }

  /**
   * Extrahiert und formatiert die Moderatoren-Daten aus den Sendungsinformationen.
   * Erstellt Objekte mit Namen, Links und Avatar-URLs.
   *
   * @param {string} [stationId] - Die ID der Station (Standard: aktuelle Station).
   * @param {object} showInfos - Das Objekt mit den Sendungsinformationen.
   * @returns {Array<object>} Ein Array mit Moderatoren-Objekten.
   * @private
   */
  function _getPresenters (stationId = getCurrentStationId(), showInfos = getDataFromStorage(stationId + '.show')) {
    let presenters = [];

    if (showInfos.hasOwnProperty('presenter')) {
      for (const presenter of showInfos.presenter) {
        let presenterObject = '';
        let avatar = '';

        if (presenter.url.hasOwnProperty('href')) {
          //Moderator hat einen Link:
          presenterObject = COMMON.Utils.template(TEMPLATES.SHOW_INFO_WITH_LINK, {
            url: presenter.url.href,
            text: presenter.displayname
          });
        } else {
          presenterObject = presenter.displayname;
        }

        if (presenter.hasOwnProperty('avatar')) {
          if (presenter.avatar.hasOwnProperty('1x1')) {
            avatar = presenter.avatar['1x1'];
          }
        }

        presenters.push({
          'presenter': presenterObject,
          'name': presenter.displayname,
          'avatar': avatar
        });
      }
    }

    return presenters;
  }

  SWRNEU.RadioData = {
    subscribeFeed: subscribeFeed,
    unsubscribeFeed: unsubscribeFeed,
    renderShowInfo: renderShowInfo,
    renderShowImage: renderShowImage,
    renderStationImage: renderStationImage,
    renderStationLinks: renderStationLinks,
    renderWellenswitcher: renderWellenswitcher,
    getDataFromStorage: getDataFromStorage,
    removeDataFromStorage: removeDataFromStorage,
    getData: getData,
    setCurrentStationId: setCurrentStationId,
    getCurrentStationId: getCurrentStationId,
    getStationDisplayName: getStationDisplayName,
    getFeedUrl: getFeedUrl
  };
})(window.jQuery);
